import React, { useState } from 'react';
import { ToggleButton, Divider, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';

interface FilterBarProps {
  i18n: any;
  selectionCallback: (selectedItem: string) => void;
}

const useStyles = makeStyles({
  row: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    ...shorthands.gap(tokens.spacingHorizontalS),
    ...shorthands.padding(tokens.spacingVerticalXXL, tokens.spacingHorizontalXXXL),
  },
  filterButton: {
    height: '32px',
    minWidth: '75px',
    whiteSpace: 'nowrap',
  },
  divider: {
    flexGrow: 'unset',
  },
});

export const FilterBar = ({ i18n, selectionCallback }: FilterBarProps) => {
  const [selectedFilter, setSelectedFilter] = useState('All sizes');
  const filterOptions = [
    { value: 'All sizes', text: _TL_('All sizes') },
    { value: 'Horizontal', text: _TL_('Horizontal') },
    { value: 'Square', text: _TL_('Square') },
    { value: 'Vertical', text: _TL_('Vertical') },
  ];
  const classes = useStyles();
  return (
    <div className={mergeClasses('preview-filter', classes.row)}>
      {filterOptions.map((filter, index) => (
        <React.Fragment key={filter.value}>
          <ToggleButton
            onClick={() => {
              selectionCallback(filter.value);
              setSelectedFilter(filter.value);
            }}
            checked={selectedFilter === filter.value}
            className={mergeClasses(`${filter.value.replace(/\s+/g, '-')}-filter`, classes.filterButton)}
          >
            {i18n.getString(filter.text)}
          </ToggleButton>
          {index === 0 && <Divider vertical className={classes.divider} />}
        </React.Fragment>
      ))}
    </div>
  );
};
